import { Routes, Route, useLocation } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import User from "./scenes/user";
import Requests from "./scenes/requests";
import Responders from "./scenes/responders";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Login from "./scenes/login";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const [theme, colorMode] = useMode();
  const location = useLocation();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
      {location.pathname !== "/login" && <Sidebar />}
      <main className="content">
        {location.pathname !== "/login" && <Topbar />}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/user" element={<ProtectedRoute element={<User />} />} />
          <Route path="/responders" element={<ProtectedRoute element={<Responders />} />} />
          <Route path="/requests" element={<ProtectedRoute element={<Requests />} />} />
        </Routes>
      </main>
    </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
